<app-navbar></app-navbar>
<div class="p-0 pt-0">
    <div class="container-fluid">
        <div class="row p-0 m-0 mb-3">
            <div class="col-md-12 p-0 m-0">
                <div class="row m-0 p-0">
                    <div class="col-12 p-0 m-0 col-md-12 text-center text-primary">
                        <h4 class="m-0 p-0 text-bold">PLATAFORMA DE RECEBIMENTO DE LEITE CRU</h4>
                    </div>
                </div>
            </div>
        </div>
        <hr class="m-0 p-0" />
        <div class="row py-2 m-0">
            <div class="col-md-6 col-12 p-2 m-0">
                <button class="form-control btn btn-outline-custom btn-lg btn-dashboard p-3" routerLink="/plataforma">
                FILA DA PLATAFORMA
                </button>
            </div>
            <div class="col-md-6 col-12 p-2 m-0">
                <button class="form-control btn btn-outline-custom btn-lg btn-dashboard p-3" routerLink="/portaria">
                ENTRADA DE CAMINHÕES
                </button>
            </div>
        </div>
        <hr class="m-0 p-0" />
    </div>
</div>
<div class="p-0 mt-2">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="row py-2 m-0">
                    <div class="col-md-6 col-12 p-2 m-0">
                        <div class="text-center mb-1">ENTRADA DE CAMINHÕES ÚLTIMOS 30 DIAS</div>
                        <canvas class="graf1" id="myChart">{{chart}}</canvas>
                    </div>
                    <div class="col-md-6 col-12 p-2 m-0">
                        <div class="text-center mb-1">HORÁRIO DE PICO DE ENTRADA</div>
                        <canvas class="graf1" id="horarioPico">{{chart}}</canvas>
                    </div>
                    <div class="col-md-6 col-12 p-2 m-0">
                        <div class="text-center mb-1">ENTRADA POR TIPO DE VEÍCULO</div>
                        <canvas class="graf1" id="tipoveiculo">{{chart}}</canvas>
                    </div>
                    <div class="col-md-6 col-12 p-2 m-0">
                        <div class="text-center mb-1">TEMPO MÉDIO POR TIPO DE VEÍCULO</div>
                        <canvas class="graf1" id="mediaveiculo">{{chart}}</canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>